import httpService from "..";

export const addFuneralTransactionApi = async (policyId: string, data: any) => {
    return await httpService(
      `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/transaction?invoiceId=${policyId}`,
      "post",
      data
    );
  };